<template>
	<div id="app">
		<div class="header" v-if="headerShow">
			<div class="nav">
				<div class="navLeft">
					<div class="list" v-for="(item,index) in tabs" :key="index" @click="tabEvent(index,item.path,item)">
						<div v-if="index!=2  ">
							<div class="image">
								<img :src="item.isActive ? item.imageActive : item.image" alt="">

							</div>
							<div class="name">
								<a :href="shop_link" class="a" v-if="item.isShow" target="_blank">
									<span :class="{isactive:item.isActive}">{{item.name}}</span>
								</a>
								<span v-else :class="{isactive:item.isActive}">{{item.name}}</span>
							</div>
						</div>
						<!-- 关于大展 -->
						<div v-if="index==2" style="position:relative;" @mouseover="mouseOver" @mouseleave="mouseLeave">
							<div class="image">
								<img :src="item.isActive ? item.imageActive : item.image" alt="">
							</div>
							<div class="name aboutShow">
								<div class="a" v-if="item.isShow">
									<span :class="{isactive:item.isActive}">{{item.name}}</span>
								</div>
								<span v-else :class="{isactive:item.isActive}">{{item.name}}</span>
							</div>
							<div class="menuList" ref="menuList">
								<div v-for="(item,index) in menuList" :key="index"
									:class="index==currentIndex?'activeMenu':''" @click="goto(item,index)">
									{{item.menutitle}}</div>
							</div>
						</div>
					</div>

				</div>
				<div class="navRight">
					<!-- <div class="search_nav" v-if="this.$route.path == '/'">
						<div class="search_icon" style="top:5px;right: 0;transform: scale(0.7);" @click="searchTab">
							<img src="./assets/image/search.png" alt="">
						</div>
						<input type="text"  v-model="message" @focus.prevent="focus" @blur.prevent="blur"
							@keyup.13="searchTab" @click="focus">

						<div class="recommend" v-if="searchBottom">
							<div class="ul">
								<div class="li" v-for="(item,index) in referral" :key="index"
									@mousedown.prevent="searchEvent(item.title,item.types)"
									@click.stop="searchEvent(item.title,item.types)">
									<span style="margin-left: 15px;" v-if="item.types== 1 && item.label_name">展厅</span>
									<span style="margin-left: 15px;" v-if="item.types== 2">投票</span>
									<span style="margin-left: 15px;" v-if="item.types== 3">新闻</span>
									<span :class="{mar:item.tpe}">{{item.title}}</span>
									<span style="float: right;margin-right: 30px;">

										<span
											:class="{success:item.label_name == '最新' || item.label_name == 'hot',fail:item.label_name == '热门'}">{{item.label_name}}</span>
										<span v-if="item.type == 4" @mousedown.stop="closeHist(item.title)"
											style="cursor: pointer;"
											@click.stop="closeHist(item.title)">{{$t('language.Delete')}}</span>
									</span>
								</div>
							</div>
						</div>


					</div> -->
					<div class="Chinese" :class="{chineseA:item.isActive}" v-for="(item,index) in chines" :key="index"
						@click="switchEvent(index)">
						<span>{{item.name}}</span>
					</div>
			<!-- 		<div style="float: left;margin-left: 15px;color:#000;">
						|
					</div>
					<div class="headImg" v-if="userInfo " @click="personal">
						<img v-if="userInfo.avatar != ''" :src="userInfo.avatar" alt="">
						<img v-else src="./assets/image/defaultHeader.png" alt="">
					</div> -->
					<!-- <div class="headImg" v-else @click="personal">
               <img src="./assets/image/defaultHeader.png"alt="">
            </div> -->
					<!-- <div class="userName" v-if="userInfo" style="color: #000;" @click="personal">
						<span v-if="userInfo.truename">{{userInfo.truename}}</span>
						<span v-else>{{userInfo.phone}}</span>
					</div>
					<div class="userName" v-else style="color: #000;" @click="loginEvent()">
						<span>{{$t('language.noLogin')}}</span>
					</div> -->
				</div>
			</div>
		</div>

		<div class="searchs" v-if="shows">
			<div class="searchBase" :style="{background:'url('+ images +')',backgroundSize:'cover'}">
				<div class="pip">
					<img src="./assets/image/pip.png" alt="">
				</div>
				<div class="search_input">
					<input type="text" class="myinput" v-model="message" @focus.prevent="focus" @blur.prevent="blur"
						@keyup.13="searchTab">
					<div class="search_icon" @click="searchTab">
						<img src="./assets/image/search.png" alt="">
					</div>
					<div class="recommend" v-if="searchBottom">
						<div class="ul">
							<div class="li" v-for="(item,index) in referral" :key="index"
								@mousedown.prevent="searchEvent(item.title,item.types)"
								@click.stop="searchEvent(item.title,item.types)">
								<span style="margin-left: 15px;" v-if="item.types== 1 && item.label_name">展厅</span>
								<span style="margin-left: 15px;" v-if="item.types== 2">投票</span>
								<span style="margin-left: 15px;" v-if="item.types== 3">新闻</span>
								<span :class="{mar:item.tpe}">{{item.title}}</span>
								<span style="float: right;margin-right: 30px;">
									<span
										:class="{success:item.label_name == '最新' || item.label_name == 'hot',fail:item.label_name == '热门'}">{{item.label_name}}</span>
									<span v-if="item.type == 4" @mousedown.stop="closeHist(item.title)"
										style="cursor: pointer;"
										@click.stop="closeHist(item.title)">{{$t('language.Delete')}}</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<transition name="fade-transform" mode="out-in">
				<router-view v-if="isRouterAlive" />
			</transition>
		</div>
		<router-view v-if="!shows" />

		<!-- 登录 -->
		<login :showModel="LoginShow" @childByValue="childByValue" @parentData="parent" @userInfo="userEvent"></login>

		<!-- 注册 -->
		<register :showModel="registerShow" @registerV="registerV"></register>

	</div>
</template>

<script>
	import login from './components/login.vue'
	import register from '@/components/register.vue'
	import fiex from '@/components/fiex.vue'
	import SearchDom from './pages/search.vue'
	export default {
		name: 'App',
		components: {
			login,
			register,
			fiex
		},
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				headerShow: true,
				move: true,
				LoginShow: false,
				registerShow: false,
				shows: false,
				images: require('./assets/image/bann.png'),
				message: '',
				userInfo: {},
				shop_link: '',
				isRouterAlive: true,
				referral: [],
				searchBottom: false,
				historyList: [],
				menuList: [{
					menutitle: this.$t('language.aboutShow'),
					link: '/newPage/aboutShow'
				}, {
					menutitle: this.$t('language.yearShow'),
					link: '/newPage/yearShow'
				}, {
					menutitle: this.$t('language.pingyaoShow'),
					link: '/newPage/pingyaoShow'
				}, {
					menutitle: this.$t('language.everyShow'),
					link: '/newPage/timeLine'
				}],
				currentIndex: 0,
				signList: [{
					menutitle: this.$t('language.Online'),
					link: '/sign'
				}, {
					menutitle: this.$t('language.Offline'),
					link: '/newPage/signUp'
				}],
				signIndex: 0
			}
		},
		computed: {

			tabs() {
				var arr = [{
						image: require('./assets/image/home1.png'),
						name: this.$t('language.home'),
						imageActive: require('./assets/image/home.png'),
						isActive: false,
						path: '/',
					},

					{
						image: require('./assets/image/new.png'),
						name: this.$t('language.Journalism'),
						isActive: false,
						imageActive: require('./assets/image/new_active.png'),
						path: '/journalism'
					},
					{
						image: require('./assets/image/aboutImg.png'),
						name: this.$t('language.aboutShow'),
						isActive: false,
						imageActive: require('./assets/image/aboutImg_active.png'),
						path: '',
					},
					{
						image: require('./assets/image/schedule.active.png'),
						name: this.$t('language.schedule'),
						imageActive: require('./assets/image/schedule.png'),
						isActive: false,
						path: '/schedule'
					},
					{
						image: require('./assets/image/contactUs.png'),
						name: this.$t('language.contact'),
						isActive: false,
						imageActive: require('./assets/image/contactUs_active.png'),
						path: '/newPage/contactInfo',
					}
				]
				return arr
			},
			chines() {
				var arr = [{
						name: this.$t('language.chines'),
						isActive: true,
						speck: 'en'
					},
					{
						name: 'En',
						isActive: false,
						speck: 'zh'
					}
				]
				return arr
			}
		},

		mounted() {
			console.log(this.$store.store.state.count)
		},

		watch: {
			// 监听路由变化 决定是否显示导航
			'$route.path': function(newVal, oldVal) {
				console.log(newVal);

				if (newVal === '/soliciting') {} else {
					this.headerShow = true
				}
				if (newVal == '/' | newVal == '/search' | newVal == '/soliciting') {
					this.shows = false;
				} else {
					this.shows = true;
				}
				for (var i = 0; i < this.tabs.length; i++) {

					this.tabs[i].isActive = false;
				}
				if (newVal == '/') {
					this.tabs[0].isActive = true;
				}
				// if (newVal == '/vote' | newVal == '/hand') {
				//   this.tabs[4].isActive = true;
				// }

				if (newVal == '/schedule') {
					this.tabs[3].isActive = true;
				}
				if (newVal == '/journalism' | newVal == '/newsDetails') {
					this.tabs[1].isActive = true;
				}
				// if (newVal == '/ShoppingMall' | newVal == '/shopDetail' | newVal == '/detail' | newVal == '/shopCar' | newVal ==
				//   '/information' | newVal == '/Cashier') {
				//   this.tabs[4].isActive = true;
				// }
				// if (newVal == '/vote' | newVal == '/hand' | newVal == '/soliciting') {
				//   this.tabs[4].isActive = true;
				// }
				if (newVal == '/newPage/aboutShow' | newVal == '/newPage/yearShow' | newVal == '/newPage/timeLine' |
					newVal == '/newPage/pingyaoShow') {
					this.tabs[2].isActive = true;
				}
				if (newVal == '/newPage/contactInfo') {
					this.tabs[4].isActive = true;
				}
			}
		},
		created() {
			if (!window.localStorage.getItem('languageSet')) {
				window.localStorage.setItem('languageSet', 'en')
			}
			this.$fetch('/index/info').then(res => {
				this.shop_link = res.data.shop_link;
				console.log(res.data)
			})
			console.log(this);
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			console.log(this.userInfo);
			if (this.$route.path == '/soliciting') {
				this.headerShow = true
			}
			if (this.$route.path == '/' | this.$route.path == '/soliciting' | this.$route.path == '/search') {
				this.shows = false;
			} else {
				this.shows = true;
			}
			this.$i18n.locale = localStorage.getItem('languageSet');
			for (var i = 0; i < this.chines.length; i++) {
				if (this.chines[i].speck == this.$i18n.locale) {
					this.chines[i].isActive = true;
				} else {
					this.chines[i].isActive = false
				}
			}
			for (var i = 0; i < this.tabs.length; i++) {
				this.tabs[i].isActive = false;
				if (this.$route.path == '/') {
					this.tabs[0].isActive = true;
				}
				if (this.$route.path == '/exhibition' | this.$route.path == '/halldetail') {
					this.tabs[1].isActive = true;
				}
				if (this.$route.path == '/schedule') {
					this.tabs[2].isActive = true;
				}
				// if (this.$route.path == '/vote' | this.$route.path == '/hand' | this.$route.path == '/soliciting') {
				//   this.tabs[4].isActive = true;
				// }
				if (this.$route.path == '/journalism' | this.$route.path == '/newsDetails') {
					this.tabs[3].isActive = true;
				}
				// if (this.$route.path == '/ShoppingMall' | this.$route.path == '/shopDetail' | this.$route.path == '/detail' |
				//   this.$route.path == '/shopCar' | this.$route.path == '/information' | this.$route.path == '/Cashier') {
				//   this.tabs[4].isActive = true;
				// }
				if (this.$route.path == '/sign' | this.$route.path == '/newPage/signUp') {
					this.tabs[4].isActive = true;
				}
				// if (newVal == '/vote' | newVal == '/hand' | newVal == '/soliciting') {
				//   this.tabs[4].isActive = true;
				// }
				if (this.$route.path == '/newPage/aboutShow' | this.$route.path == '/newPage/yearShow' | this.$route
					.path == '/newPage/timeLine' | this.$route.path == '/newPage/pingyaoShow') {
					this.tabs[5].isActive = true;
				}
				if (this.$route.path == '/newPage/contactInfo') {
					this.tabs[6].isActive = true;
				}
			}
		},
		methods: {
			goBao: function() {
				this.$router.push('/newPage/signUp')
			},
			focus() {
				// console.log(this.$store.store.commit);
				this.$store.store.commit('focus');
				localStorage.setItem('isIndex', '1');
				if (JSON.parse(localStorage.getItem("historyList"))) {
					this.historyList = JSON.parse(localStorage.getItem("historyList"));
				}
				var arr = [];
				for (var i = 0; i < this.historyList.length; i++) {
					var obj = {};
					obj.title = this.historyList[i];
					obj.type = 4;
					obj.types = 1;
					obj.tpe = true;
					arr.push(obj);
				}
				var result = [];
				var obj = {};
				for (var i = 0; i < arr.length; i++) {
					if (!obj[arr[i].title]) {
						result.push(arr[i]);
						obj[arr[i].title] = true;
					}
				}
				console.log(result);
				this.$fetch('/search/referral').then(res => {
					this.referral = res.data.concat(result);
				})
				this.searchBottom = true;
			},
			searchTab() {
				if (!this.historyList.includes(this.message)) {
					this.historyList.unshift(this.message);
					var newArr = [];
					for (var i = 0; i < this.historyList.length; i++) {
						if (newArr.indexOf(this.historyList[i]) == -1) {
							newArr.push(this.historyList[i]);
						}
					}
					localStorage.setItem("historyList", JSON.stringify(newArr));
				} else {
					localStorage.setItem("historyList", JSON.stringify(this.historyList));
				}
				console.log(this.message)
				this.$router.push({
					path: '/search',
					query: {
						msg: this.message,
						types: 1
					}
				})

			},
			searchEvent(data, type) {
				console.log(data, type,'12312312312-----')
				this.message = data;
				this.$router.push({
					path: '/search',
					query: {
						msg: data,
						types: type
					}
				})
				this.message = '';
				location.reload()
			},
			closeHist(name) {
				this.searchBottom = true;
				var historyList = window.localStorage.getItem('historyList');
				historyList = JSON.parse(historyList);
				for (var i = 0; i < historyList.length; i++) {
					if (name == historyList[i]) {
						if (historyList.length == 1) {
							window.localStorage.setItem('historyList', '[]')
						}
					} else {
						if (!arr) {
							var arr = [];
						}
						arr.push(historyList[i]);
						console.log(arr);
						console.log('');
						window.localStorage.setItem('historyList', JSON.stringify(arr))
					}
				}
			},
			blur() {
				this.$store.store.commit('blur');
				localStorage.setItem('isIndex', '0');
				this.searchBottom = false;
			},
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(() => {
					this.isRouterAlive = true;
				})
			},
			parent(data) {
				if (data) {
					this.LoginShow = false;
				}
				this.registerShow = data;
			},
			userEvent(data) {
				this.userInfo = data;
			},
			tabEvent(index, path, item) {

				// for (var i = 0; i < this.tabs.length; i++) {
				//   this.tabs[i].isActive = false;
				// }
				// this.tabs[index].isActive = true;
				if (this.$route.path == '/journalism') {
					localStorage.removeItem('index');
					localStorage.removeItem('id');
					localStorage.removeItem('pages')
				}
				if (path == '/') {
					this.$router.push({
						path: '/'
					});
				} else {
					this.$router.push(path)
				}

				if (this.$route.path == '/sign') {
					if (!localStorage.getItem('access_token')) {
						this.$message.error(this.$t('language.onLogin'));
						this.$router.push('/')
					}
				}

			},
			tabMove(index) {
				this.move = false
			},
			personal() {
				this.$router.push('/personal')
			},
			switchEvent(index) {

				this.$i18n.locale = this.chines[index].speck;
				// setTimeout(() => {
				//   window.location.reload()
				// }, 1000)
				this.$router.go(0)
				localStorage.setItem('languageSet', this.$i18n.locale)
				for (var i = 0; i < this.chines.length; i++) {
					if (this.chines[i].speck == this.$i18n.locale) {
						this.chines[i].isActive = true;
					} else {
						this.chines[i].isActive = false
					}
				}

			},
			// searchEvent() {
			//   this.$router.push({
			//     path: '/search',
			//     query: {
			//       msg: this.massage,
			//       types: 1
			//     }
			//   })
			// },
			loginEvent() {
				console.log('1231')
				this.LoginShow = true;
			},
			childByValue(data) {
				this.LoginShow = data;
			},
			registerEvent() {
				this.registerShow = true;
			},
			registerV(data) {
				this.registerShow = data;
			},
			// 关于大展
			goto(item, index) {
				this.currentIndex = index;
				this.$router.push(item.link)
			},
			// 报名
			gotoSign(item, index) {
				console.log(window.location.hash)
				if (window.location.hash == "#/sign") {
					console.log("我在报名")
					location.reload()
				}
				this.signIndex = index;
				this.$router.push(item.link)
			},
			mouseOver() {
				let menuList = document.getElementsByClassName("menuList")[0];
				menuList.style.display = "block";
			},
			mouseLeave() {
				let menuList = document.getElementsByClassName("menuList")[0];
				menuList.style.display = "none";
			},

			signMouseOver() {
				let signList = document.getElementsByClassName("signList")[0];
				signList.style.display = "none";
			},
			signMouseLeave() {
				let signList = document.getElementsByClassName("signList")[0];
				signList.style.display = "none";
			},
		}
	}
</script>

<style>
	.search_nav {
		width: 240px;
		height: 30px;
		background-color: #fff;
		float: left;
		margin-top: 5px;
		position: relative;
		border-radius: 5px;
	}
	.search_nav > input{
		width: 240px;
		height: 30px;
		padding-left: 10px;
		border-radius: 5px;
		box-sizing: border-box;
	}
	body {
		overflow-y: hidden;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.recommend {
		width: 100%;
		height: 139px;
		background: rgb(250, 250, 250, 1);
		position: absolute;
		top: 36px;
		left: 0;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		z-index: 99999999999;
		overflow-y: auto;
		scrollbar-width: none;
		color: #000000;
		font-size: 12px;
	}

	.success {
		color: #299BFB;
	}

	.mar {
		margin-left: 15px;
	}

	.fail {
		color: #FB3515;
	}

	.hp_scroll,
	.hp_scroll_listen {
		position: absolute;
		overflow-x: hidden;
		overflow-y: auto;
		scrollbar-width: none;
		width: 100%;
		transition: 1s;
		z-index: 99999999999;
	}

	.hp_scroll_listen {
		bottom: 0;
		z-index: 99999999;
	}

	.ul {
		width: 100%;
		height: 100%;
		font-size: 16px;
	}

	.li {
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 12px;
	}

	.li:hover {
		background: rgb(0, 0, 0, .05);
	}

	#app {
		font-family: 'MicrosoftYaHei';
	}

	* {
		margin: 0;
		padding: 0;
		list-style: none;
		border: none;
		outline: none;
	}


	::-webkit-scrollbar {
		display: none;
	}

	/*
  @media screen and (max-width: 1200px){
  	::-webkit-scrollbar {
		display: block!important;
		z-index: 999!important;
  	}
  } */


	.header {
		width: 100%;
		height: 40px;
		position: fixed;
		top: 0;
		line-height: 40px;
		z-index: 999;
		color: #FFFFFF;
	}

	.a {
		color: #FFFFFF;
		text-decoration: none;
	}

	.nav {
		width: 90%;
		height: 100%;
		margin: auto;
		display: flex;
		justify-content: space-between;
	}

	ul {
		color: #FFFFFF;
	}

	.list:nth-of-type(1) {
		margin-left: 0;
	}

	.fade-transform-leave-active,
	.fade-transform-enter-active {
		transition: all 0.5s;
	}

	/*
  enter定义进入过渡的开始状态
   */
	.fade-transform-enter {
		opacity: 0;
		transform: translateX(-30px);
	}

	/*
  leave-to离场动画结束后的状态
   */
	.fade-transform-leave-to {
		opacity: 0;
		transform: translateX(30px);
	}

	.list {
		float: left;
		width: auto;
		height: 100%;
		line-height: 40px;
		font-size: 18px;
		margin-left: 37px;
		cursor: pointer;
		color: #000;
	}

	.image {
		width: 18px;
		height: 16px;
		float: left;
		margin-top: 2px;
	}

	.image>img {
		width: 18px;
		height: 16px;
		margin-top: 5px;
	}

	.name {
		float: left;
		margin-left: 6px;
	}

	.navLeft {
		min-width: 70%;
		height: 100%;
	}

	.navRight {
	}

	.isactive {
		color: #af011a;
	}

	.Chinese {
		float: left;
		color: #000;
		margin-left: 20px;
		cursor: pointer;
		font-size: 18px;
	}

	.headImg {
		width: 31px;
		height: 31px;
		float: left;
		margin-left: 17px;
		border-radius: 50%;
		overflow: hidden;
		margin-top: 5px;
		cursor: pointer;
	}

	.headImg>img {
		width: 100%;
		height: 100%;
	}

	.userName {
		float: left;
		margin-left: 17px;
		cursor: pointer;
		font-size: 18px;
		color: #000!important;
	}

	.chineseA {
		color: #af011a;
	}

	.searchBase {
		width: 100%;
		height: 160px;
		background: rgba(0, 0, 0, 0.6);
	}

	.searchs {
		width: 100%;
		height: 100vh;
	}

@media screen and (max-width:1200px)  {
		.search_nav{
			width: 140px!important;
		}
		.search_nav > input{
			width: 140px!important;
		}
	}
	@media screen and (min-width:1201px) and (max-width:1600px)  {
			.search_nav{
				width: 180px!important;
			}
			.search_nav > input{
				width: 180px!important;
			}
		}
	@media screen and (max-width:1100px) {
		.search_input {
			width: 600px !important;
		}
	}

	@media screen and (max-width:890px) {
		.search_input {
			width: 400px !important;
		}

	}

	.pip {
		width: 83px;
		height: 80px;
		float: left;
		margin-left: 168px;
	}

	.pip>img {
		width: 100%;
		height: 100%;
		margin-top: 55px;
	}

	.search_input {
		width: 789px;
		height: 59px;
		background: #FFFFFF;
		float: left;
		margin-left: 30px;
		margin-top: 70px;
		border-radius: 4px;
		/* overflow: hidden; */
		position: relative;
	}


	.myinput {
		width: 100%;
		height: 100%;
		padding-left: 15px;
	}

	.search_icon {
		width: 31px;
		height: 31px;
		position: absolute;
		right: 30px;
		top: 14px;
	}

	.search_icon>img {
		width: 100%;
		height: 100%;
	}

	.menuList {
		transition: all 1s;
		width: 100%;
		background: #000000;
		position: absolute;
		text-align: center;
		background-color: rgba(110, 110, 110, 0.6);
		top: 40px;
		left: -8px;
		font-size: 16px;
		padding: 0px 10px;
		display: none;
	}

	.menuList>div:not(:last-child) {
		border-bottom: 1px dashed #FFFFFF;
	}

	.activeMenu {
		color: #AF011A;
	}

	.signList {
		transition: all 1s;
		width: 100%;
		background: #000000;
		position: absolute;
		text-align: center;
		background-color: rgba(110, 110, 110, 0.6);
		top: 40px;
		left: -15px;
		font-size: 16px;
		padding: 0px 10px;
		display: none;
	}

	.signList>div:not(:last-child) {
		border-bottom: 1px dashed #FFFFFF;
	}

	.list:nth-of-type(5) .signList {
		width: 120%;
		/* background: #af011a; */
	}
</style>



// WEBPACK FOOTER //
// src/App.vue